import { React } from "react";
import { useSelector, useDispatch } from "react-redux";
import { CheckboxField, RadioGroupField, Radio, Flex, TextAreaField } from '@aws-amplify/ui-react';
import { typedReturnValue } from '../anamnese_lib/validateInteger';

const SubjektiveBeeintraechtigung = (props) => {
    const daten = useSelector(state => state.anamnese.Daten);
    const dispatch = useDispatch();

    const handleChange = (e) => {
        // console.log(e.target)
        const key = e.target.name;
        const val = typedReturnValue(key, e.target.value);
        dispatch({ type: 'anamnese/Modify', payload: { [key]: val } });
        props.handleChange(e);
    }

    const handleCheck = (e) => {
        const key = e.target.name;
        const val = e.target.value === 'on' ? 1 : 0;
        dispatch({ type: 'anamnese/Modify', payload: { [key]: val } });
        props.handleChange(e);
    }


    return (
        <>
            <h4>2.3 Subjektive Beeinträchtigung der Aktivitäten und Teilhabe</h4>
            <p>Bei welchen Tätigkeiten sind Sie durch Ihre Erkrankung eingeschränkt?</p>
            <TextAreaField
                name="SELBSTEIN"
                width="100%"
                defaultValue={daten.SELBSTEIN}
                onChange={handleChange}
                descriptiveText="Im Beruf:"
                wrap="nowrap"
                maxLength={256}
                rows={2}
                readOnly={props.readOnly}
            />
            <TextAreaField
                name="SELBSTEIN_ALLTAG"
                width="100%"
                defaultValue={daten.SELBSTEIN_ALLTAG}
                onChange={handleChange}
                descriptiveText="Im Alltag:"
                wrap="nowrap"
                maxLength={256}
                rows={2}
                readOnly={props.readOnly}
            />
            <p></p>
            <p>Was hilft Ihnen, mit den Einschränkungen zurecht zu kommen?</p>
            <Flex direction="row">
                <CheckboxField
                    name="HILFE_KG"
                    value={daten.HILFE_KG === 1 ? "off" : "on"}
                    checked={daten.HILFE_KG === 1}
                    onChange={handleCheck}
                    label="Physiotherapie"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="HILFE_WARME"
                    value={daten.HILFE_WARME === 1 ? "off" : "on"}
                    checked={daten.HILFE_WARME === 1}
                    onChange={handleCheck}
                    label="Wärme"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="HILFE_KAELTE"
                    value={daten.HILFE_KAELTE === 1 ? "off" : "on"}
                    checked={daten.HILFE_KAELTE === 1}
                    onChange={handleCheck}
                    label="Kälte"
                    disabled={props.readOnly}
                />
                </Flex>
                <Flex direction="row">

                <CheckboxField
                    name="HILFE_MEDI"
                    value={daten.HILFE_MEDI === 1 ? "off" : "on"}
                    checked={daten.HILFE_MEDI === 1}
                    onChange={handleCheck}
                    label="Medikamente"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="HILFE_BEWEGUNG"
                    value={daten.HILFE_BEWEGUNG === 1 ? "off" : "on"}
                    checked={daten.HILFE_BEWEGUNG === 1}
                    onChange={handleCheck}
                    label="Bewegung"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="HILFE_RUHE"
                    value={daten.HILFE_RUHE === 1 ? "off" : "on"}
                    checked={daten.HILFE_RUHE === 1}
                    onChange={handleCheck}
                    label="Ruhe"
                    disabled={props.readOnly}
                />
            </Flex>
            <TextAreaField
                name="SELBSTEIN_HILFE"
                width="100%"
                defaultValue={daten.SELBSTEIN_HILFE}
                onChange={handleChange}
                descriptiveText="Sonstiges:"
                wrap="nowrap"
                maxLength={256}
                rows={2}
                readOnly={props.readOnly}
            />
            <p></p>
            <h5>Einschätzung Ihrer beruflichen Situation</h5>
            <RadioGroupField
                value={daten.BERUFL_SITUATION}
                onChange={handleChange}
                descriptiveText=""
                name="BERUFL_SITUATION">
                {['Ich werde an meinen Arbeitsplatz zurückkehren und sehe keine Schwierigkeiten.',
                    'Ich habe keinen Arbeitsplatz und weiß nicht, wie ich beruflich wieder Fuß fassen kann.',
                    'Ich habe einen Arbeitsplatz, aber kann meine Tätigkeit nicht mehr oder nur noch mit Mühen ausüben.'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.BERUFL_SITUATION !== i ? props.readOnly : false}>{item}</Radio>)}
                    
            </RadioGroupField>
            {daten.BERUFL_SITUATION === 2 &&
                <TextAreaField
                    name="BERUFL_SITUATION_TXT"
                    width="100%"
                    defaultValue={daten.BERUFL_SITUATION_TXT}
                    onChange={handleChange}
                    descriptiveText="Was belastet Sie besonders (Arbeitsschwere, Zeitdruck, Konflikte ...)?"
                    wrap="nowrap"
                    maxLength={256}
                    rows={2}
                    readOnly={props.readOnly}
                />
            }
            {daten.BERUFL_SITUATION !== 1 &&
                <CheckboxField
                    name="BERUFL_SITUATION_KONSEQ"
                    value={daten.BERUFL_SITUATION_KONSEQ === 1 ? "off" : "on"}
                    checked={daten.BERUFL_SITUATION_KONSEQ === 1}
                    onChange={handleCheck}
                    label="Ich war häufig krankgeschrieben und befürchte Konsequenzen am Arbeitsplatz."
                    disabled={props.readOnly}
                />
            }
            {daten.BERUFL_SITUATION !== 0 &&
                <CheckboxField
                    name="BERUFL_SITUATION_NO"
                    value={daten.BERUFL_SITUATION_NO === 1 ? "off" : "on"}
                    checked={daten.BERUFL_SITUATION_NO === 1}
                    onChange={handleCheck}
                    label="Ich denke, dass ich überhaupt nicht mehr arbeiten kann."
                    disabled={props.readOnly}
                />
            }
        </>
    )
}

export default SubjektiveBeeintraechtigung;
